module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-5.b4bc2d5b.mp3";